module.exports = flarum.core.compat['tags/utils/sortTags'];